module.exports = __webpack_public_path__ + "img/coca1.36eb03d6.png";